import { NgModule } from '@angular/core';
import { AeButtonsComponent } from './ae-buttons/ae-buttons.component';
import { AeButtonsButtonComponent } from './ae-buttons/ae-buttons-button.component';
import { AeButtonsBackComponent } from './ae-buttons-back/ae-buttons-back.component';
import { AeCardsComponent } from './ae-cards/ae-cards.component';
import { AeInfosComponent } from './ae-infos/ae-infos.component';
import { AeTabsComponent } from './ae-tabs/ae-tabs.component';
import { AeTabsItemComponent } from './ae-tabs/ae-tabs-item.component';
import { AeTagsComponent } from './ae-tags/ae-tags.component';
import { AeHrComponent } from './ae-hr/ae-hr.component';
import { AeContentLoadComponent } from './ae-content-load/ae-content-load.component';
import { AeToastComponent } from './ae-toast/ae-toast.component';

@NgModule({
  declarations: [
    AeButtonsComponent,
    AeButtonsBackComponent,
    AeButtonsButtonComponent,
    AeCardsComponent,
    AeContentLoadComponent,
    AeHrComponent,
    AeInfosComponent,
    AeTabsComponent,
    AeTabsItemComponent,
    AeTagsComponent,
    AeToastComponent

  ],
  imports: [],
  exports: [
    AeButtonsComponent,
    AeButtonsBackComponent,
    AeButtonsButtonComponent,
    AeCardsComponent,
    AeContentLoadComponent,
    AeHrComponent,
    AeInfosComponent,
    AeTabsComponent,
    AeTabsItemComponent,
    AeTagsComponent,
    AeToastComponent
  ],
})
export class AgendaEduModule {}
